var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.596 0 0 5.596 0 12.5S5.596 25 12.5 25 25 19.404 25 12.5 19.404 0 12.5 0zm-.003 5.313a1.896 1.896 0 1 1 0 3.792 1.896 1.896 0 0 1 0-3.792zm3.256 14.231c0 .19-.153.343-.343.343H9.583a.343.343 0 0 1-.342-.343v-.703c0-.19.153-.343.342-.343h1.102v-6.67H9.55a.343.343 0 0 1-.342-.344v-.704c0-.19.153-.343.342-.343h4.427c.19 0 .343.154.343.343v7.718h1.092c.189 0 .342.153.342.343v.703z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.1bf4abddfc4a6492b90cf4b7652be31d.svg";
export { ForwardRef as ReactComponent };